import type { LandXDeclineReasonCode } from "api/landlord-surveys/land-x.types";

// Structured decline reasons for a premium rental history survey.
// On a survey routed to a Boom network partner, `not_managed` and `no_records`
// hand the survey on to the applicant's landlord contact instead of ending it.
export const DECLINE_REASON_OTHER: LandXDeclineReasonCode = "other";

const DECLINE_REASON_LABELS: Record<
  Exclude<LandXDeclineReasonCode, "other">,
  string
> = {
  policy: "I can only provide rental verification via phone",
  no_records: "I don't have any records of this tenant",
  not_managed: "This property is not managed by my company"
};

export const DECLINE_REASON_OPTIONS: {
  value: LandXDeclineReasonCode;
  label: string;
}[] = [
  { value: "policy", label: DECLINE_REASON_LABELS.policy },
  { value: "no_records", label: DECLINE_REASON_LABELS.no_records },
  { value: "not_managed", label: DECLINE_REASON_LABELS.not_managed },
  { value: DECLINE_REASON_OTHER, label: "Other" }
];

const isPresetCode = (
  code: string
): code is Exclude<LandXDeclineReasonCode, "other"> =>
  code in DECLINE_REASON_LABELS;

export const declineReasonLabel = (
  code?: string | null,
  text?: string | null
): string => {
  if (code && isPresetCode(code)) return DECLINE_REASON_LABELS[code];
  return text?.trim() ?? "";
};
